import { render, staticRenderFns } from "./Records.vue?vue&type=template&id=dd919992&scoped=true&"
import script from "./Records.vue?vue&type=script&lang=ts&"
export * from "./Records.vue?vue&type=script&lang=ts&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./Records.vue?vue&type=style&index=1&id=dd919992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd919992",
  null
  
)

export default component.exports